const DELETED_MESSAGE_PLACEHOLDER = 'This message has been deleted';

function isUsableUserMessage(message) {
  if (!message || message.role !== 'user') return false;
  if (message.flags?.isDeleted) return false;
  const content = typeof message.content === 'string' ? message.content.trim() : '';
  return !!content && content !== DELETED_MESSAGE_PLACEHOLDER;
}

export function findLastUsableUserPrompt(messages) {
  if (!Array.isArray(messages)) return '';
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const message = messages[i];
    if (!isUsableUserMessage(message)) continue;
    return String(message.content).trim();
  }
  return '';
}

export function restoreLastUserPromptToComposer(conversationId, { contextId = 'new' } = {}) {
  if (!conversationId) return false;
  try {
    const { useChatStore, useChatInputStore } = require('@/store');
    const chat = useChatStore.getState().chats.find(c => c.id === conversationId);
    const prompt = findLastUsableUserPrompt(chat?.messages);
    if (!prompt) return false;
    const input = useChatInputStore.getState();
    if (contextId === conversationId) {
      return input.restoreRejectedPrompt(contextId, prompt);
    }
    input.setContext(contextId);
    input.setText(prompt);
    return true;
  } catch (error) {
    console.error('Failed to restore composer prompt:', error);
    return false;
  }
}

export function isConversationMissingError(message) {
  return typeof message === 'string' && /conversation not found/i.test(message);
}

export function getConversationRecoveryMessage(message, errorCode) {
  if (errorCode === 'agent_unavailable' || errorCode === 'agent_not_found'
      || /^Invalid agent:|^Agent not found$/i.test(message || '')) {
    return 'This bot is unavailable. Choose Arya, Auto, or another bot to continue in this chat.';
  }
  if (errorCode === 'conversation_load_failed' || errorCode === 'conversation_archived'
      || /^This chat (could not be loaded right now|is archived)\./.test(message || '')) {
    return message;
  }
  return null;
}
